module.exports = __webpack_public_path__ + "static/media/gear light.143c8405.png";